import Outmazedlogo from '../../assets/footerLogo.svg';
import getFooterDetails, { socialLinks } from './FooterConfig';
import FooterMobile from './FooterMobile';
import { Link } from 'react-router-dom';
import { PAGE_URL } from '../../config/appConfig';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { BsEnvelope, BsEnvelopeFill, BsTelephoneFill } from 'react-icons/bs';
import { FaLocationDot } from 'react-icons/fa6';
import { capitalize } from 'lodash';
import cardsLogo from '../../assets/cardsLogo.png';
import { createIdFromTitle } from '../../utils/utils';

const Footer = () => {

  const { SectionData } = useSelector((state) => state.siteInfo);
  const [service, setService] = useState([]);
  const { SectionData: services } = useSelector((state) => state.services);
  useEffect(() => {
    if (services) {
      const newData = services.Services.map(({ Title }) => ({
        label: Title.split(' ')
          .map((word) => capitalize(word))
          .join(' '),
        href: `${PAGE_URL.SERVICE}${createIdFromTitle(Title)}`,
      }));
      setService(newData);
    }
  }, [services]);




  return (
    <>
      <div
        className='container-fluid GlobalContainer py-0'
        data-aos='fade-right'
      >
        <div className='row footerBg d-md-block d-none'>
          <div className='container'>
            <div className='row justify-content-evenly'>
              <div
                className='col-md-2 Fcol Fcol1 text-center'
                data-aos='fade-up'
              >
                <Link className='' to='/'>
                  <img
                    src={SectionData && SectionData?.SiteFooterLogo?.url}
                    width='132'
                    alt={SectionData ? SectionData?.SiteFooterLogo.altTag : ''}
                  />
                </Link>
              </div>
              <div
                className='col-md-3 Fcol get-in-touch-web'
                data-aos='fade-up'
              >
                <span>Get In Touch</span>
                <ul>
                  <li>
                    <a
                      href={`tel://${SectionData && SectionData?.SitePhoneNumber
                        }`}
                    >
                      <BsTelephoneFill />
                      {SectionData && SectionData?.SitePhoneNumber}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`mailto:${SectionData && SectionData?.SiteEmail
                        }`}
                    >
                      <BsEnvelopeFill />
                      {SectionData && SectionData?.SiteEmail}
                    </a>
                  </li>
                  <li>
                    <a href='#'>
                      <FaLocationDot />
                      {SectionData && SectionData?.SiteAddress}
                    </a>
                  </li>
                  <li>
                    <a href='#'>
                      <FaLocationDot />
                      F, Warehouse # S08, Mena Jabal Ali, Jabal Ali Industrial First, Dubai, United Arab Emirates
                    </a>
                  </li>

                </ul>
                <div className='SocialMediaLink'>
                  {socialLinks?.map(
                    (socialItem, index) =>
                      SectionData && SectionData[socialItem.cmsUrl] && (
                        <a
                          target='_blank'
                          href={
                            SectionData[socialItem.cmsUrl]
                          }
                          key={index}
                        >
                          {socialItem.icon}
                        </a>
                      )


                  )}
                </div>
              </div>
              {getFooterDetails().map((data, index) => (
                <div
                  className={`col-md-3 Fcol ${data?.class} ${data?.btnClass}`}
                  data-aos='fade-up'
                  key={index}
                >
                  {data.detailName === 'SERVICES' ? (
                    <>
                      <span> {data.detailName} </span>
                      <ul>
                        {service.map((detail, index) => (
                          <li key={index}>
                            <Link to={detail.href}>{detail.label}</Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <>
                      <span> {data.detailName} </span>
                      <ul>
                        {data.subHeading.map((detail, index) => (
                          <li key={index}>
                            <Link to={detail.href}>{detail.label}</Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='row text-center text-white d-md-flex d-none justify-content-center py-2'>
          <div>
            <img src={cardsLogo} alt="Cards Logos" width="320px" />
          </div>

        </div>
        <div className='row Finfo d-md-block d-none'>
          <ul>
            <li>
              &copy; {new Date().getFullYear()} Outmazed<sup>&reg;</sup> Design. All Rights Reserved
            </li>
            <li>
              <Link to={PAGE_URL.TERMS_OF_USE}>Terms of Use</Link>
            </li>
            <li>
              <Link to={PAGE_URL.PRIVACY}>Privacy Policy</Link>
            </li>
            <li>
              <Link to={PAGE_URL.FAQ}>FAQs</Link>
            </li>
            <li>
              <Link to={PAGE_URL.CANCELLATION_PAGE}>Cancellation Policy</Link>
            </li>
            <li>
              <Link to={PAGE_URL.REFUND_PAGE}>Refund Policy</Link>
            </li>
            <li>
              <Link to={PAGE_URL.COOKIE_PAGE}>Cookie Policy</Link>
            </li>
          </ul>
        </div>
        <FooterMobile />
      </div>
    </>
  );
};

export default Footer;
